import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] px-4 sm:px-6 py-8">
      <div className="max-w-3xl mx-auto">
        {/* Back Link */}
        <Link 
          to="/register" 
          className="inline-flex items-center gap-2 text-neutral-400 hover:text-white transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Registration
        </Link>

        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-white mb-2">Terms of Service</h1>
          <p className="text-neutral-400">Last updated: March 01, 2026</p>
        </div>

        {/* Content */}
        <div className="prose prose-invert max-w-none space-y-8">
          <p className="text-neutral-300">
            By using RydQuest ("the Platform"), operated by <strong>R3V Ventures INC.</strong>, you agree to the following Terms of Service.
          </p>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-white">1. Use of the Platform</h2>
            <p className="text-neutral-300">You agree to use the platform only for lawful purposes and in accordance with these terms.</p>
            <p className="text-neutral-300">You must not:</p>
            <ul className="list-disc list-inside text-neutral-300 space-y-1 ml-4">
              <li>Provide false information</li>
              <li>Use the platform for fraudulent activity</li>
              <li>Interfere with or disrupt the platform</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-white">2. Accounts</h2>
            <p className="text-neutral-300">To use certain features, you must create an account.</p>
            <p className="text-neutral-300">You are responsible for:</p>
            <ul className="list-disc list-inside text-neutral-300 space-y-1 ml-4">
              <li>Maintaining the confidentiality of your account</li>
              <li>All activity under your account</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-white">3. Bookings</h2>
            <p className="text-neutral-300">RydQuest is a car community platform for events, sidequests, and automotive culture.</p>
            <p className="text-neutral-300">We do not guarantee:</p>
            <ul className="list-disc list-inside text-neutral-300 space-y-1 ml-4">
              <li>Availability of services</li>
              <li>Quality of services provided by businesses</li>
            </ul>
            <p className="text-neutral-300">All bookings are subject to acceptance by the business.</p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-white">4. Communications</h2>
            <p className="text-neutral-300">By using the platform, you consent to receive communications related to bookings via:</p>
            <ul className="list-disc list-inside text-neutral-300 space-y-1 ml-4">
              <li>Email</li>
              <li>SMS</li>
            </ul>
            <p className="text-neutral-300">Standard carrier fees may apply.</p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-white">5. Payments & Subscriptions</h2>
            <p className="text-neutral-300">If applicable:</p>
            <ul className="list-disc list-inside text-neutral-300 space-y-1 ml-4">
              <li>Businesses may pay subscription fees to use the platform</li>
              <li>Referral programs may provide compensation based on active subscriptions</li>
            </ul>
            <p className="text-neutral-300">We reserve the right to modify pricing at any time.</p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-white">6. Referral Program</h2>
            <p className="text-neutral-300">Users participating in referral programs agree that:</p>
            <ul className="list-disc list-inside text-neutral-300 space-y-1 ml-4">
              <li>Payments are conditional on active subscriptions</li>
              <li>We may modify or terminate the program at any time</li>
              <li>Abuse or fraud will result in removal from the program</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-white">7. User Content</h2>
            <p className="text-neutral-300">You may submit content (e.g., listings, messages).</p>
            <p className="text-neutral-300">You grant us a non-exclusive license to use, display, and distribute this content as part of the platform.</p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-white">8. Limitation of Liability</h2>
            <p className="text-neutral-300">RydQuest is provided "as is" without warranties.</p>
            <p className="text-neutral-300">We are not liable for:</p>
            <ul className="list-disc list-inside text-neutral-300 space-y-1 ml-4">
              <li>Service interruptions</li>
              <li>Business actions or failures</li>
              <li>Loss of data or profits</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-white">9. Termination</h2>
            <p className="text-neutral-300">We may suspend or terminate your account if you violate these terms.</p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-white">10. Changes to Terms</h2>
            <p className="text-neutral-300">We may update these Terms at any time. Continued use of the platform constitutes acceptance of the updated terms.</p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-white">11. Governing Law</h2>
            <p className="text-neutral-300">These Terms are governed by the laws of British Columbia, Canada.</p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-white">12. Contact</h2>
            <p className="text-neutral-300">For questions, contact:</p>
            <p className="text-neutral-300">
              <strong>R3V Ventures INC.</strong><br />
              Email: <a href="mailto:info@r3vit.com" className="text-red-400 hover:text-red-300">info@r3vit.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
